import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Btn, H3, P } from "../../../AbstractElements";
import { useForm } from 'react-hook-form';
import { Row, Col, Container, Card, CardBody, CardFooter, Form } from 'reactstrap'
import TableBuilder, { RegisteredInputsBuilder, ApiRequestBuilder, ToastBuilder, FormOptionsBuilder, ButtonBuilder, ModalButtonBuilder, VerticalButtonGroup, HoverOver } from '../../../GlobalComponents/Builders';
import { buildOptionsFromArray, buildSelectOptionsFromArray, setInitialFormValues, sortArrayByKey, uploadPresignedFile, statusCodeText, tabTag, parseTextFromHTML } from '../../../GlobalComponents/Helpers';
import { AccountContext } from '../../../GlobalComponents/Authentication/Accounts';
import { ContentLoader } from '../../../Layout/Loader';
import SectionCard from '../../../GlobalComponents/Common/Component/SectionCard';
import ApiExplorerModal from '../../Tools/Tool/Jobs/Job/DMT/components/toolbox/ApiExplorer/ApiExplorerModal';
import moment from 'moment';
import 'moment-timezone';

const Connection = () => {

    const styles = {
        eyeDiv: {
            position: 'absolute',
            width: '35px',
            right: '15px',
            top: '10%',
            cursor: 'pointer',
            height: '25px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        eye: {
            opacity: 0,
            transition: 'opacity 0.75s ease',
        }
    }

    const navigate = useNavigate();

    let { connectionId } = useParams();

    const { isAdmin } = useContext(AccountContext);

    const [secretVisible, setSecretVisible] = useState({});

    /**
     * Create a global variable to store the original connection data
     * once it is retrieved since the timing of the nested API calls
     * does not work with the state updates.
     */
    let tempConnectionData = {}

    const [isProcessing, setIsProcessing] = useState(true);
    const [allowUpload, setAllowUpload] = useState(true);
    const [testResults, setTestResults] = useState('Click Test');
    const [connectionData, setConnectionData] = useState(null);
    const [serviceData, setServiceData] = useState(null);
    const [serviceResources, setServiceResources] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const [logData, setLogData] = useState([]);
    const [logsLoaded, setLogsLoaded] = useState(false);

    const { register, handleSubmit, getValues, setValue, resetField, control, formState: { errors } } = useForm();

    const refreshLogs = () => {
        if (!isAdmin || !connectionData) return;
        ApiRequestBuilder('connectionsConnectionIdLogsGet', { connectionId: connectionData.connection_id })
            .then(function (results) {
                setLogData(results.data && results.data.length > 0 ? results.data : []);
                setLogsLoaded(true);
                console.log('Log .response (first 3):', results.data ? results.data.slice(0, 3).map(log => log.response) : []);
            });
    }

    const handleConnectionTest = (formData) => {

        let resourceToTest = serviceResources.find(resource => parseInt(resource.resource_id) === parseInt(formData.resourceToTest))

        setTestResults(<div className='d-flex justify-content-center align-items-center'>
            <pre style={{ fontSize: 15, fontWeight: 500, width: 'fit-content', maxWidth: '100%' }}>Testing Connection . . .</pre></div>)

        ApiRequestBuilder('connectionsConnectionIdTestPost', { connectionId: connectionData.connection_id }, { resourceToTest: formData.resourceToTest }).then(function (results) {

            let statusCode = <>StatusCode {results.data.status}:{tabTag}{tabTag}{statusCodeText(results.data.status)}</>

            if (results.data && results.data.success) {
                ToastBuilder('success', 'Connection Test Successful')
                setTestResults(<div className='d-flex justify-content-center align-items-center'>
                    <pre style={{ fontSize: 17, fontWeight: 500, width: 'fit-content', maxWidth: '100%', color: 'green' }}>{statusCode}<br /><strong>{resourceToTest.name}</strong> Test Success!</pre></div>)
            }
            else {
                ToastBuilder('error', 'Connection Test Error')
                let endpointUsed = <>API Endpoint:{tabTag}{tabTag}{tabTag} /{results.data.uri}</>
                let errorMessage = results.data.text ? results.data.text : 'No additional information was provided by the API.'

                try {
                    errorMessage = JSON.stringify(errorMessage, null, 4)
                } catch { }

                errorMessage = parseTextFromHTML(errorMessage).trim()
                // replace all multiple line breaks with a single line break
                errorMessage = errorMessage.replace('\n \n', '\n').replace(/(\r\n|\n|\r|\n)+/gm, '\n')

                setTestResults(<div className='d-flex justify-content-center align-items-center'>
                    <pre style={{ color: 'red', fontSize: 15, fontWeight: 500, width: 'fit-content', maxWidth: '100%', textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {endpointUsed}<br />{statusCode}<br />{errorMessage}
                    </pre>
                </div>)
            }

            refreshLogs();

        }).catch((error) => {
            console.log(error)
            ToastBuilder('error', 'Connection Test Error')
            setTestResults(<div className='d-flex justify-content-center align-items-center'>
                <pre style={{ color: 'red', fontSize: 15, fontWeight: 600, width: 'fit-content', maxWidth: '100%', textAlign: 'left' }}>
                    Error testing connection. Please try again later.
                </pre>
            </div>)
            refreshLogs();
        })
    }

    const handleDisableConnection = () => {

        ApiRequestBuilder('connectionsConnectionIdDelete', { connectionId: connectionData.connection_id }, { body: 'empty' }).then(function (results) {
            window.location.href = process.env.PUBLIC_URL + '/connections/'
        })
    }

    const handleDocumentUpload = (file) => {

        if (file['connectionFileToUpload'].length === 0) {
            ToastBuilder('error', 'Please Select a File to Upload')
        }
        else {
            uploadPresignedFile(file['connectionFileToUpload'], 'filesUploadPost', null, {
                bucket: process.env.REACT_APP_FILES_BUCKET,
                key: file['connectionFileToUpload'][0].name,
                type: 'connection',
                metadata: {
                    connectionid: connectionData.connection_id
                }
            }, () => { setSpinner(true); getConnectionData() }, { timeout: '5000' })
        }
    }

    const onConnectionEdit = (connectionInformation) => {
        ApiRequestBuilder('connectionsConnectionIdPatch', { connectionId }, { ...connectionInformation }).then(function (results) {
            ToastBuilder('success', 'Connection Updated Successfully')
            setTestResults('Click Test')
            getConnectionData()
        })
    }

    const getConnectionData = () => {
        console.log(isAdmin)

        ApiRequestBuilder('connectionsConnectionIdGet', { connectionId })
            .then(function (results) {

                tempConnectionData = results.data

                let settings = { connectionName: results.data.name, ...results.data.settings }
                tempConnectionData.settings = isAdmin ? settings : results.data.settings
                setConnectionData(tempConnectionData)
                setValue('description', results.data.description || '')
                console.log('ConnectionDetails', tempConnectionData.settings)

                /**
                 * If we have a location, don't allow user to overwrite the file
                 */
                results.data.location && results.data.location !== 'None' ? setAllowUpload(false) : null

                ApiRequestBuilder('servicesServiceIdGet', { serviceId: results.data.service_id }, null, { setIsProcessing })
                    .then(function (results) {
                        let serviceDataSettings = results.data?.settings
                        if (isAdmin) {
                            serviceDataSettings = [
                                {
                                    name: 'connectionName',
                                    label: 'Connection Name',
                                    datatype: 'text',
                                },
                                ...results.data.settings
                            ]
                            results.data.settings = serviceDataSettings
                        }
                        setServiceData(results.data)
                        setInitialFormValues(tempConnectionData.settings, setValue)
                    })

                ApiRequestBuilder('servicesServiceIdResourcesGet', { serviceId: results.data.service_id })
                    .then(function (results) {
                        if (results.data && results.data.length > 0) {
                            setServiceResources(sortArrayByKey(results.data[0].resources
                                .filter(resource => resource.resource && !resource.parent_resource_id)
                                , 'name'))
                        }
                    })

                if (isAdmin) {
                    ApiRequestBuilder('connectionsConnectionIdLogsGet', { connectionId: results.data.connection_id })
                        .then(function (results) {
                            console.log('Log .response (first 3):', results.data ? results.data.slice(0, 3).map(log => log.response) : []);
                            setLogData(results.data && results.data.length > 0 ? results.data : []);
                            setLogsLoaded(true);
                        })
                }
            }
            )
    }

    const togglePasswordVisibility = (field) => {
        setSecretVisible((prevState) => ({
            ...prevState,
            [field]: !prevState[field]
        }))
    }

    useEffect(() => {

        document.title = 'View Connection'
        getConnectionData()

    }, []);

    return (
        <Fragment>
            <style>
                {`
            input::-ms-reveal, input::-ms-clear {
                display: none;
            }
            input::-ms-reveal, input::-ms-clear {
                position: 'absolute,
                width: '35px',
                right: '15px',
                top: '10%',
                cursor: 'pointer',
                height: '25px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }
            `}
            </style>
            <ContentLoader isLoading={isProcessing} />
            <Container fluid={true}>
                {serviceData && connectionData ?
                    <div className="edit-profile">
                        <Row>
                            <Col xl="7">
                                <Form id='update-connection'
                                    autoComplete='off'
                                    data-form-type='other'
                                    onSubmit={handleSubmit(onConnectionEdit)}>
                                    <Card>
                                        <CardBody>
                                            <Row className="mb-2">
                                                <div className="profile-title">
                                                    <div className="media">
                                                        <div className="media-body">
                                                            <H3 attrH3={{ className: 'mb-1 f-20 txt-primary' }}>{connectionData.name}{isAdmin ? (' (' + connectionData.connection_id + ')') : ''}</H3>
                                                            <P>{serviceData ? serviceData.name : ''}</P>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                            <RegisteredInputsBuilder
                                                registrator={register}
                                                registratorErrors={errors}
                                                inputs={
                                                    serviceData ? serviceData.settings.flatMap(setting => {
                                                            const input = {
                                                                label: setting.label,
                                                                labelSize: 3,
                                                                inputSize: 8,
                                                                name: setting.name,
                                                                type: 'text',
                                                                style: setting.datatype === 'password' && !secretVisible[setting.name]
                                                                    ? { WebkitTextSecurity: 'disc' }
                                                                    : {},
                                                                helpText: setting.helpText,
                                                                addOn: setting.datatype === 'password' && isAdmin ? (
                                                                    <div id={`eye-${setting.name}-div`} style={styles.eyeDiv}>
                                                                        <style>{`#eye-${setting.name}-div:hover i { opacity: 1!important; }`}</style>
                                                                        <i id={`eye-${setting.name}`} onClick={() => togglePasswordVisibility(setting.name)}
                                                                            className={`fa fa-eye${secretVisible[setting.name] ? '-slash' : ''}`} style={styles.eye} />
                                                                    </div>
                                                                ) : null,
                                                            };
                                                            // Description sits right after the Connection Name field.
                                                            if (setting.name === 'connectionName') {
                                                                return [input, {
                                                                    label: 'Description',
                                                                    labelSize: 3,
                                                                    inputSize: 8,
                                                                    name: 'description',
                                                                    type: 'textarea',
                                                                    required: false,
                                                                }];
                                                            }
                                                            return [input];
                                                        })
                                                        : []
                                                }
                                            />
                                        </CardBody>
                                        <CardFooter className="d-flex justify-content-between p-3">
                                            <ButtonBuilder form='' label='Back' className='btn-secondary m-2' onClick={() => navigate(`${process.env.PUBLIC_URL}/connections`)} />
                                            <div className='h-100'>
                                                <ButtonBuilder form='' label='Disable Connection' className='btn-danger' onClick={handleDisableConnection} />
                                                <ButtonBuilder form='update-connection' label='Update' className='btn-primary m-2' color='primary' />
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </Form>
                            </Col>
                            {connectionData.type !== 'csv' && serviceResources.length > 0 ?
                                <Col xl="5">
                                    <Card>
                                        <CardBody>
                                            <center>
                                                <h4>Connection Status</h4>
                                                <br />
                                                <h6>{testResults}</h6>
                                                <br />
                                                <ModalButtonBuilder title='Test Connection' className='btn-primary'
                                                    body={
                                                        <Form id='test-connection-form' onSubmit={handleSubmit((formData) => handleConnectionTest(formData))}>
                                                            <p>Use this connection tester to verify we have access to the endpoints required for whatever task(s) will be completed using this connection.</p>
                                                            <br />
                                                            <RegisteredInputsBuilder
                                                                registrator={register}
                                                                registratorErrors={errors}
                                                                control={control}
                                                                inputs={[
                                                                    {
                                                                        label: 'Resource',
                                                                        type: 'reactselect',
                                                                        size: 12,
                                                                        labelSize: 3,
                                                                        inputSize: 8,
                                                                        required: false,
                                                                        options: buildSelectOptionsFromArray(serviceResources, { label: 'name', value: 'resource_id' }),
                                                                        name: 'resourceToTest'
                                                                    },
                                                                ]} />
                                                        </Form>
                                                    }
                                                />
                                            </center>
                                        </CardBody>
                                    </Card>
                                </Col> : null}
                            {connectionData && connectionData.type === 'csv' ?
                                <Col xl="5">
                                    <Form onSubmit={handleSubmit(handleDocumentUpload)}>
                                        <Card>
                                            <CardBody>
                                                <Row className="mb-2">
                                                    <div className="profile-title">
                                                        <div className="media">
                                                            <div className="media-body">
                                                                <H3 attrH3={{ className: 'mb-1 f-20 txt-primary' }}>File Upload</H3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Row>
                                                <RegisteredInputsBuilder
                                                    registrator={register}
                                                    registratorErrors={errors}
                                                    inputs={
                                                        allowUpload ? [
                                                            {
                                                                label: 'Choose A File',
                                                                size: 12,
                                                                name: 'connectionFileToUpload',
                                                                type: 'file',
                                                            }
                                                        ] : [
                                                            {
                                                                label: 'Connected File',
                                                                size: 12,
                                                                name: 'connectedFile',
                                                                type: 'static',
                                                                value: connectionData.location.split('/')[connectionData.location.split('/').length - 1]
                                                            }
                                                        ]
                                                    }
                                                />
                                            </CardBody>
                                            <CardFooter className="text-end">
                                                {allowUpload ? <ButtonBuilder className='mb-2' label='Upload File' type='submit' useSpinner={true} /> : null}
                                            </CardFooter>
                                        </Card>
                                    </Form>
                                </Col> : null}
                        </Row>
                        {isAdmin && <Row>
                            <Col xl="12">
                                <SectionCard title='Logs' badge={logsLoaded ? String(logData.length) : undefined} badgeColor='info' defaultOpen={false}>
                                    <TableBuilder
                                        data={logData}
                                        processing={!logsLoaded}
                                        pagination={true}
                                        paginationPerPage={10}
                                        sortField={5}
                                        sortOrderAsc={false}
                                        title=''
                                        columns={[
                                            {
                                                name: 'Resource ID',
                                                selector: (row) => row.resource_id,
                                                sortable: true,
                                                center: true,
                                                maxWidth: '12%',
                                            },
                                            {
                                                name: 'Resource',
                                                selector: (row) => row.resource || '-',
                                                sortable: true,
                                                center: true,
                                            },
                                            {
                                                name: 'Success',
                                                selector: (row) => {
                                                    if (row.success) {
                                                        return <span style={{ color: 'green' }}>Yes</span>;
                                                    }
                                                    if (row.response) {
                                                        const errorText = typeof row.response === 'object'
                                                            ? JSON.stringify(row.response, null, 4)
                                                            : String(row.response);
                                                        return <HoverOver
                                                            content={errorText}
                                                            text={<span style={{ color: 'red', cursor: 'pointer' }}>No</span>}
                                                            contentStyle={{ maxHeight: 400, padding: '10px 20px' }}
                                                            keepHovered={true}
                                                        />;
                                                    }
                                                    return <span style={{ color: 'red' }}>No</span>;
                                                },
                                                sortable: true,
                                                center: true,
                                                maxWidth: '12%',
                                            },
                                            {
                                                name: 'Requested By',
                                                selector: (row) => row.requested_by_name || row.requested_by || '-',
                                                sortable: true,
                                                center: true,
                                                maxWidth: '20%',
                                            },
                                            {
                                                name: 'Requested At',
                                                selector: (row) => row.requested_at
                                                    ? moment.utc(row.requested_at * 1000).tz('America/New_York').format('YYYY-MM-DD hh:mm:ss A')
                                                    : '-',
                                                sortable: true,
                                                center: true,
                                                maxWidth: '20%',

                                            },
                                        ]}
                                    />
                                </SectionCard>
                            </Col>
                        </Row>}
                        {isAdmin && connectionData.type !== 'csv' && <Row>
                            <Col xl="12">
                                <SectionCard title='API Explorer' badge='Admin' badgeColor='warning' defaultOpen={false}>
                                    <ApiExplorerModal
                                        connectionId={connectionData.connection_id}
                                        serviceCode={connectionData.service_code}
                                        connectionName={connectionData.name}
                                        trigger={<ButtonBuilder label='Open API Explorer' className='btn-warning' useSpinner={false} />}
                                    />
                                </SectionCard>
                            </Col>
                        </Row>}
                    </div> : null}
            </Container>
        </Fragment>
    );
};
export default Connection;